<template>
	<div>
		<p style="font-size: 1.5rem;margin:2.5rem;color: rgba(0, 0, 0, 0.85);">{{title}}</p>
		<div v-html="msg" style="margin: 0 1.875rem">
		</div>
	</div>
</template>

<script>
	export default{
		props:['msg','title']
	}
</script>

<style>
</style>
